<template>
  <nav class="navigation-panel">
    <div class="navigation-panel-home">
      <i class="icf-arrowLeft icf-icon"></i>
      <slot />
    </div>

    <div class="navigation-panel-inner">
      <div class="navigation-panel-tabs">
        <slot name="tabs" />
      </div>
    </div>
    <div class="navigation-panel-ghost" />
  </nav>
</template>

<style lang="less" scoped>
@import '~@npm/@gd/common-styles/lib/color-vars';

@navigationbreakpoint: 960px;

.navigation-panel {
  width: 100%;
  background-color: @c0;
  text-align: left;
  min-height: 3.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid @c0-b;
  &-inner {
    position: relative;
    flex: 1 1 100%;
    overflow-x: hidden;
    overflow-y: visible;
    min-height: 3.5em;
  }
  &-ghost {
    flex: 1 4 9em;
  }
}
.navigation-panel-home {
  position: relative;
  padding: 0.3em;
  color: @c0-j;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1 0 auto;
  a {
    color: @c0-j;
    cursor: pointer;
    text-decoration: none;
    border-bottom: 1px solid @c0-j;
    font-size: 0.875em;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    &:hover {
      color: @c0-h;
      border-bottom: 1px solid @c0-g;
    }
  }
  i {
    padding-right: 0.25em;
  }
}
.navigation-panel-tabs {
  padding: 0 2em;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  max-width: 100%;
  justify-content: center;
}
</style>
